module.exports = __webpack_public_path__ + "static/media/ts14tj823.248a3f02.png";